import React from "react";
import { Box } from "@mui/material";

// import Signupgraphic from "../../assets/signupgraphic.png";
import Logingraphic from "../../assets/signup.png";

import { Typography } from "@mui/material";
import { LoginDetails } from "./LoginDetails";
import { none } from "@hookstate/core";

export const Login = () => {
	return (
		<>
			<Box
				sx={{
					// width: "100%",
					height: "100%",
					display: "flex",
					// flexWrap: "wrap",
					flexDirection: { xs: "column", md: "row" },
					padding: { xs: 1, md: 2 },
					justifyContent: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: { xs: "center", md: "row" },
						background: "#FFFFFF",
						boxShadow: "0px 15px 55px 1px #E6E6E6",
						borderRadius: "12px",
						// width: { xs: "100%", md: "70%" },
						// height: "",
						width: { xs: "100%", md: "80%" },
						justifyContent: "center",
					}}
				>
					<Box
						sx={{
							// width: { xs: "100%", md: "50%" },
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							justifyItems: "center",
							alignItems: "center",
							alignContent: "center",
						}}
					>
						<LoginDetails />
					</Box>
					<Box
						sx={{
							width: { xs: "100%", md: "500px" },
							// height: "calc(100vh - 70px)",
							display: { xs: "none", md: "flex" },
							flexDirection: "column",
							px: { xs: 1, md: 1 },
						}}
					>
						<Box
							component="img"
							sx={{
								objectFit: "contain",
							}}
							src={Logingraphic}
							// sx={{ marginTop: 5 }}
						/>
					</Box>
				</Box>
			</Box>
		</>
	);
};
